/**
 * 资料
 */

 import Layout from '@/layout/Layout.vue'

 export default {
  path: '/export',
  component: Layout,
  children: [
    {
      path: '',
      name: '导入导出管理',
      component: () => import('@/views/download/Index.vue'),
      meta: {
        keepAlive: true,
        pageName: 'export'
      }
    },
  ],
}